import aiProfilesJson from './ai-profiles.json'
import { assetsFileSchema, type AssetsFile } from './assetSchema'
import assetsJson from './assets.json'
import bindingsJson from './bindings.json'
import fieldJson from './field.json'
import {
  aiProfilesFileSchema,
  bindingsSchema,
  fieldConfigSchema,
  shipsFileSchema,
  toAiData,
  toFieldConfig,
  toWavesData,
  toWeaponsData,
  wavesFileSchema,
  weaponsFileSchema,
  worldSchema,
  type AiData,
  type Bindings,
  type FieldConfig,
  type ShipDef,
  type WavesData,
  type WeaponsData,
  type WorldConfig,
} from './schemas'
import { mergeShipEntries } from './shipExtends'
import { resolveShips } from './shipResolve'
import shipsJson from './ships.json'
import wavesJson from './waves.json'
import weaponsJson from './weapons.json'
import worldJson from './world.json'

export interface GameData {
  /** Runtime ship defs resolved against the asset manifest; `Ship.defIndex` indexes this. */
  ships: ShipDef[]
  weapons: WeaponsData
  aiProfiles: AiData
  waves: WavesData
  field: FieldConfig
  bindings: Bindings
  world: WorldConfig
  assets: AssetsFile
}

/** Parses, validates and cross-resolves all bundled data. Throws a ZodError naming the bad field, or an Error naming the bad reference. */
export function loadGameData(): GameData {
  const assets = assetsFileSchema.parse(assetsJson)
  const weapons = toWeaponsData(weaponsFileSchema.parse(weaponsJson))
  // M10 P1d: `extends` entries are merged over their base (and `flightBand` preset) before resolving.
  const ships = resolveShips(mergeShipEntries(shipsFileSchema.parse(shipsJson).ships), assets, weapons)
  const aiProfiles = toAiData(aiProfilesFileSchema.parse(aiProfilesJson))
  return {
    ships,
    weapons,
    aiProfiles,
    waves: toWavesData(wavesFileSchema.parse(wavesJson), ships, aiProfiles.profiles),
    field: toFieldConfig(fieldConfigSchema.parse(fieldJson)),
    bindings: bindingsSchema.parse(bindingsJson),
    world: worldSchema.parse(worldJson),
    assets,
  }
}
